<template>
  <i18n-link
    :to="routeObject"
    :class="[$style.root, !onEditionPage ? $style['color-scheme'] : '']"
    :style="cssColors"
    v-animated-underline-mouse-events
  >
    <div>
      <span
        class="animated-underline"
        v-html="title"
        :data-ignore="slug === $route?.params?.slug ? '' : null"
        :data-active="slug === $route?.params?.slug ? '' : null"
      />
    </div>
  </i18n-link>
</template>

<script lang="ts" setup>
const props = defineProps({
  data: Object,
  onEditionPage: {
    type: Boolean,
    default: false
  }
})

const title = computed(() => {
  if (!props?.data) { return null }
  const title = props?.data?.title?.trim()
  if (!title) { return null }
  const biennialEntryTitle = props?.data?.biennialEntry?.title?.trim()
  return [biennialEntryTitle, title].filter(Boolean).join('<br />')
})

const colors = props.data?.biennialEntry?.colors
const cssColors = getCssColors(colors)

const routeObject = computed(() => {
  return props?.onEditionPage ? getEducationSlugPath(props?.data?.slug, props?.data?.biennialEntry?.slug) : getEducationSlugPath(props?.data?.slug, null)
})

const slug = computed(() => {
  return props?.data?.slug
})
</script>

<style module>
.root {
  composes: font-size-small reset-link button-rectangular from global;
  display: flex;
  justify-content: center;

  text-align: center;
}

.color-scheme {
  color: var(--color--primary);
  background-color: var(--color--background);
}
</style>
